import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import PropTypes from 'prop-types';
import { UserLoginStats } from '../analytics/UserLoginStats.jsx';

const UsersPage = () => {
  return (
    <Container>
      <UserLoginStats />
    </Container>
  );
};

UsersPage.propTypes = {
  me: PropTypes.shape({
    permissions: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default connect((state) => ({
  me: state.admin.me,
}))(UsersPage);
